import React, { useEffect, useState } from 'react';
import search_icon from '../../assets/images/search_icon.png';
import brownfilter_icon from '../../assets/images/brownfilter_icon.png';
import edit_icon from '../../assets/images/edit_icon.png';
import delete_icon from '../../assets/images/delete_icon.png';
import { GetAllAttributes, DeleteAttribute } from '../../Services/AttributeService';
import { GetAllAttributeValue, DeleteAttributeValue } from '../../Services/AttributeValuesService';
import AddAttributeValue from '../AddAttributeValue';
import AddAttributeModal from '../AddAttributeModal';
import DeleteConfirmModal from '../DeleteConfirmModal';

export default function Filters() {
  const [activeTab, setActiveTab] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [attributeValues, setAttributeValues] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAttributeValue, setSelectedAttributeValue] = useState(null);
  const [productAttributeId, setProductAttributeId] = useState(null);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Main Attribute states
  const [showAttrPopup, setShowAttrPopup] = useState(false);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [showDeleteAttr, setShowDeleteAttr] = useState(false);
  const [deleteAttrId, setDeleteAttrId] = useState(null);

  useEffect(() => {
    loadAttributes();
  }, []);

  useEffect(() => {
    if (activeTab) {
      loadAttributeValues(activeTab, searchTerm);
      setProductAttributeId(activeTab);
    }
  }, [activeTab, searchTerm]);

  const loadAttributes = async (selectId = null) => {
    const response = await GetAllAttributes();
    if (response.status) {
      setAttributes(response.data);
      if (response.data.length > 0) {
        // If a specific ID was passed (e.g. newly created/updated), select it
        if (selectId && response.data.some(a => a.id === selectId)) {
          setActiveTab(selectId);
          setProductAttributeId(selectId);
        } else {
          setActiveTab(response.data[0].id);
          setProductAttributeId(response.data[0].id);
        }
      } else {
        setActiveTab(null);
        setProductAttributeId(null);
      }
    } else {
      console.error('Failed to fetch attributes:', response.message);
    }
  };

  const loadAttributeValues = async (attrId, term = "") => {
    const params = { productAttributeId: attrId };
    if (term) params.name = term;
    const response = await GetAllAttributeValue(params);
    if (response.status) {
      setAttributeValues(response.data || []);
    } else {
      console.error('Failed to fetch attribute values:', response.message);
      setAttributeValues([]);
    }
  };

  const confirmDelete = async () => {
    const response = await DeleteAttributeValue(deleteId);

    if (response?.status) {
      loadAttributeValues(activeTab, searchTerm);
      setShowDelete(false);
      setDeleteId(null);
    } else {
      alert("Failed to delete. Please try again.");
    }
  };

  const confirmDeleteAttribute = async () => {
    const response = await DeleteAttribute(deleteAttrId);
    if (response?.status) {
      setShowDeleteAttr(false);
      setDeleteAttrId(null);
      loadAttributes();
    } else {
      alert("Failed to delete attribute. Please make sure it is not in use.");
    }
  };

  return (
    <div className="dashboard mt-5">
      <div className="d-flex justify-content-between align-items-center mt-4 mb-5">
        <h2>Attributes</h2>
        <div className="d-flex gap-3">
          <button className="add-product-btn" onClick={() => { setSelectedAttribute(null); setShowAttrPopup(true); }}>
            + ADD Attribute
          </button>
          <button className="add-product-btn" onClick={() => setShowPopup(true)}>
            + ADD Attribute Values
          </button>
        </div>
      </div>

      {/* Tabs + Search */}
      <div className="order-list">
        <div className="order-header" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
          <div className="tabs" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
            {attributes.map((attr) => (
              <button
                key={attr.id}
                className={activeTab === attr.id ? 'active' : ''}
                onClick={() => setActiveTab(attr.id)}
              >
                {attr.name}
              </button>
            ))}

            {activeTab && (
              <div className="d-flex gap-2 ms-3 align-items-center" style={{ borderLeft: '1px solid #ccc', paddingLeft: '12px' }}>
                <button 
                  className="btn btn-sm btn-outline-secondary py-1"
                  style={{ borderRadius: '6px', fontSize: '12px' }}
                  onClick={() => {
                    const currentAttr = attributes.find(a => a.id === activeTab);
                    setSelectedAttribute(currentAttr);
                    setShowAttrPopup(true);
                  }}
                >
                  Edit Tab Name
                </button>
                <button 
                  className="btn btn-sm btn-outline-danger py-1"
                  style={{ borderRadius: '6px', fontSize: '12px' }}
                  onClick={() => {
                    setDeleteAttrId(activeTab);
                    setShowDeleteAttr(true);
                  }}
                >
                  Delete Tab
                </button>
              </div>
            )}
          </div>

          <div className="search-tools ms-auto">
            <div className="search-wrapper">
              <input type="search" style={{ width: "350px" }} placeholder="Search Values" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
              <div className="icons">
                <img src={search_icon} alt="Search" className="search-icon" />
                <img src={brownfilter_icon} alt="Filter" className="filter-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Attribute Values Cards */}
      {activeTab && (
        <div className="wheat-stats d-flex flex-wrap gap-3 mb-5 mt-5">
          {attributeValues.length === 0 ? (
            <p className="text-muted w-100 text-center py-4">No attribute values found.</p>
          ) : (
            attributeValues.map((value, idx) => (
              <div key={idx} className="wheat-card">
                <h5 className="mb-1">{value.name || value}</h5>
                {value.increasePrice !== undefined && value.increasePrice !== null && (
                  <div className="text-muted mb-2" style={{ fontSize: '12px' }}>
                    Rate: +₹{Number(value.increasePrice).toFixed(0)}/Kg
                  </div>
                )}
                <div className="card-icons d-flex gap-2 mt-2">
                  <img src={edit_icon} style={{ cursor: "pointer" }} onClick={() => { setSelectedAttributeValue(value); setShowPopup(true) }} alt="Edit" className="icon-edit" />
                  <img src={delete_icon} style={{ cursor: "pointer" }} onClick={() => { setDeleteId(value.id); setShowDelete(true) }} alt="Delete" className="icon-delete" />
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {/* Attribute Values Popup Modal */}
      {showPopup && <AddAttributeValue onClose={() => { setShowPopup(false); setSelectedAttributeValue(null); loadAttributeValues(activeTab); }} attributeValue={selectedAttributeValue} productAttributeId={productAttributeId} />}

      {/* Attribute Popup Modal */}
      {showAttrPopup && <AddAttributeModal onClose={() => { setShowAttrPopup(false); setSelectedAttribute(null); loadAttributes(activeTab); }} attribute={selectedAttribute} />}

      {/* Delete Value Popup */}
      <DeleteConfirmModal show={showDelete} itemName="Attribute Value" onClose={() => setShowDelete(false)} onConfirm={confirmDelete} />

      {/* Delete Attribute Popup */}
      <DeleteConfirmModal show={showDeleteAttr} itemName="Attribute Category" onClose={() => setShowDeleteAttr(false)} onConfirm={confirmDeleteAttribute} />
    </div>
  );
}
